// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"99":"550233aba7b02b06","168":"69d7b0594648c5f0"}[chunkId] + ".js";
};